import { render, staticRenderFns } from "./customer-display.vue?vue&type=template&id=90cf4230"
import script from "./customer-display.vue?vue&type=script&lang=js"
export * from "./customer-display.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports